import { render, staticRenderFns } from "./ModalCadastroEnderecoPessoa.vue?vue&type=template&id=0ac366ae"
import script from "./ModalCadastroEnderecoPessoa.vue?vue&type=script&lang=js"
export * from "./ModalCadastroEnderecoPessoa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports